import React from 'react';
import Svg, { SvgProps, Polygon } from 'react-native-svg';
const SvgSlant = (props: SvgProps) => (
  <Svg viewBox="0 0 143 6" height='6' preserveAspectRatio='none' {...props}>
    <Polygon fill={props.fill} points="0 2 143 0 143 6 0 6"></Polygon>
  </Svg>
);
export default SvgSlant;

